import { megaAppHost, securityAppHost } from '../host'
import Cookies from 'js-cookie'

export const shoppingService = async (app_name?: string) => {
  // 参数app_name 是为了服务端请求设计，获取请求cookie里的app_name，因为服务端拿不到客户端的cookie
  const appName = app_name ?? Cookies.get('app_name')
  if (appName === 'eufy_mega') {
    return `${await megaAppHost('shopping')}/app/shopping`
  }
  return `${await securityAppHost()}/v1/shopping`
}
